<div class="avi-component-adder">
    <avi-dropdown-button
        [actions]="addDropdownActions"
        [position]="actionPosition"
        size="sm"
        [disabled]="disableAdd"
    >
        {{ addLabel }}
    </avi-dropdown-button>
    <avi-fieldset
        [hidden]="selectedComponents.length"
        [hideContent]="true"
        class="avi-component-adder__fieldset"
    >
        <avi-fieldset_header class="avi-component-adder__header">
            <div class="avi-component-adder__header-text">
                {{ noSelectedComponentsLabel }}
            </div>
        </avi-fieldset_header>
    </avi-fieldset>
    <div class="avi-component-adder__component-container">
        <avi-component-outlet
            *ngFor="let selectedComponent of selectedComponents; trackBy: trackByItem; let i = index"
            [component]="selectedComponent.component"
            [componentBindings]="selectedComponent.componentBindings"
            [index]="i"
            indexAlias="{{ indexAlias }}"
        ></avi-component-outlet>
    </div>
</div>
